import React, { useState, useEffect } from "react"
import TableContent from "./tableContent"
import ErrorResponse from "../../common/errorResponse"
import { orderBy } from "lodash"
import { PlatformLegend } from "./platformLegend"
import { SearchFilter } from "./searchFilter"
import {
  getHearingInstruments,
  getHearingInstrumentsWithSearch,
} from "../../../services/ManageHearingInstruments"

function HearingInstruments() {
  const [hearingInstruments, setHearingInstruments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [statusCode, setStatusCode] = useState(200)
  const [sort, setSort] = useState("hearingInstrumentName asc")
  const [pageNumber, setPageNumber] = useState(1)
  const [isLastPage, setIsLastPage] = useState(false)
  const [selectedColumn, setSelectedColumn] = useState(null)
  const [searchValue, setSearchValue] = useState("")
  const pageSize = 50

  useEffect(() => {
    async function fetchHearingInstruments() {
      setIsLoading(true)
      let hearingInstrumentsData
      if (selectedColumn && searchValue) {
        hearingInstrumentsData = await getHearingInstrumentsWithSearch(
          pageSize,
          pageNumber,
          selectedColumn,
          searchValue
        )
      } else {
        hearingInstrumentsData = await getHearingInstruments(
          pageSize,
          pageNumber
        )
      }
      processApiResult(hearingInstrumentsData)
      setIsLastPage(
        hearingInstrumentsData.data &&
          hearingInstrumentsData.data.length < pageSize
      )
      setIsLoading(false)
    }
    fetchHearingInstruments()
  }, [pageNumber, selectedColumn, searchValue])

  const processApiResult = (hearingInstrumentsData) => {
    if (hearingInstrumentsData.statusCode === 200) {
      setHearingInstruments(hearingInstrumentsData.data)
      setStatusCode(200)
    } else {
      setHearingInstruments([])
      setStatusCode(hearingInstrumentsData.statusCode)
    }
  }

  const performSorting = (sortField, order) => {
    const sortedHearingInstruments = orderBy(
      hearingInstruments,
      [sortField],
      [order]
    )
    setHearingInstruments(sortedHearingInstruments)
  }

  const setSorting = (sortField) => {
    const prevOrder = sort.split(",")[1] || "desc"
    const order = prevOrder === "asc" ? "desc" : "asc"
    const newSort = [sortField, order].join(",")
    setSort(newSort)
    performSorting(sortField, order)
  }

  const handleColumnSelect = (column) => {
    setSelectedColumn(column)
    setSearchValue("")
    setPageNumber(1)
  }

  const updateSearch = (search) => {
    setPageNumber(1)
    setSearchValue(search)
  }

  if (statusCode !== 200 && statusCode !== 404) {
    return <ErrorResponse statusCode={statusCode} />
  }

  return (
    <div className="col-md-12">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h2 className="mb-0">
            <b>Hearing Instruments</b>
          </h2>
          <div className="p-4">
            <SearchFilter
              selectedColumn={selectedColumn}
              handleColumnSelect={handleColumnSelect}
              searchValue={searchValue}
              updateSearch={updateSearch}
            />
          </div>
        </div>
        <PlatformLegend />
      </div>
      <TableContent
        hearingInstruments={hearingInstruments}
        isLoading={isLoading}
        sort={sort}
        setSorting={setSorting}
        setPageNumber={setPageNumber}
        pageNumber={pageNumber}
        isLastPage={isLastPage}
      />
    </div>
  )
}

export default HearingInstruments
